/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { replaceTenantParam } from '../../Utilities/ReplaceTenantParam/ReplaceTenantParam';
import { DashboardCardProps } from './DashboardCard.props';

/**
 * Dashboard card.
 */
export const DashboardCard = (props: DashboardCardProps): JSX.Element => {
  const navigate = useNavigate();
  const { classes, clickAction, description, icon, link, title } = props;

  const dashboardCardClass = clsx(`dashboard-card`, classes);

  // Navigate to card path
  const handleNavigation = useCallback(
    (cardPath: string): void => {
      const path = replaceTenantParam(cardPath);
      navigate(path);
    },
    [navigate],
  );

  // Handle click
  const handleClick = (event: React.MouseEvent): void => {
    event.preventDefault();

    if (clickAction) {
      clickAction();
    } else if (link) {
      handleNavigation(link);
    }
  };

  return (
    <div className={dashboardCardClass} key={title}>
      <button aria-label={title} className="dashboard-card__link" onClick={handleClick}>
        <div className="dashboard-card__heading">
          <div className="dashboard-card__icon">{icon}</div>
          <h3 className="dashboard-card__title">{title}</h3>
        </div>
        <div className="dashboard-card__description">{description}</div>
      </button>
    </div>
  );
};
